/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { APP_INFO_ACTION_TYPES } from '../../redux-saga/actionTypes';
import styles from './styles';

class IpAppInfoServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { t, classes, info, info_loading, info_error, getInfo } = this.props;
    return (
      <div className={classes.container}>
        <br />
        <br />
        <h3>
          {t('screens.IpAppInfo.title6')}
        </h3>
        <br />
        <ButtonGroup size="small" color="primary">
          <Button onClick={() => getInfo('default')}>
            {t('screens.IpAppInfo.button1')}
          </Button>
          <Button onClick={() => getInfo('tmna')}>
            {t('screens.IpAppInfo.button2')}
          </Button>
          <Button onClick={() => getInfo('densoten')}>
            {t('screens.IpAppInfo.button3')}
          </Button>
          <Button onClick={() => getInfo('panasonic')}>
            {t('screens.IpAppInfo.button4')}
          </Button>
        </ButtonGroup>
        <br />
        <br />
        {
          info_loading ?
            'Loading...' :
          null
        }
        {
          info !== null && !info_loading?
            info.map((item) => <pre key={item.app_id}>{JSON.stringify(item, null, 2)}</pre>) :
          null
        }
         {
          info_error !== null && !info_loading?
            'Error while fetching App Info' :
          null
        }
      </div>
    );
  }
}

IpAppInfoServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  info_loading: PropTypes.bool,
  info: PropTypes.any,
  info_error: PropTypes.any,
  getInfo: PropTypes.func.isRequired,
};

IpAppInfoServices.defaultProps = {
  info: [],
  info_error: null,
  info_loading: false,
};

const mapStateToProps = state => {
  return {
    info_loading: state.info.info_loading,
    info: state.info.info,
    info_error: state.info.info_error,
  };
};

const mapDispatchToProps = dispatch => ({
  getInfo: supplier => dispatch({ type: APP_INFO_ACTION_TYPES.GET.IN_PROGRESS, payload: supplier }),
});

export default withTranslation()(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(IpAppInfoServices),
  ),
);
